// src/features/Lookup/pages/cityPage.tsx

import DynamicTable from '@/common/components/DynamicTable/DynamicTable';
import type { ColumnsType } from 'antd/es/table';
import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import type { CityType } from '../../types/lookupTypes';
import { Button } from 'antd';
import { router } from '../../../../app/routing';



const CityPage = () => {
   

    // Define columns for the PlanGroup table
    const CityColumns: ColumnsType<CityType> = [
        {
            title: 'Name',
            key: 'name',
            render: (_, record) => (
                <Button
                    type="link"
                    onClick={() => {
                        router.navigate({
                            to: '/lookup/city/CityFormRoute', // Corrected path
                            state: { record: record } as Record<string, unknown>,
                        });
                    }}
                >
                    {record.name}
                </Button>
            ),
        },
        //{ title: "Name", dataIndex: "name", key: "name" },
        { title: "Country", dataIndex: "country", key: "country" },
    ];

    return (
        <div>
            
            <DynamicTable<CityType> // Ensure generic type matches the data
                dataApiUrl={API_ENDPOINTS.LOOKUP.GET_CITY} // Your API endpoint for fetching menus
                baseQueryKey={QUERY_KEYS.LOOKUP.CITY} // Unique query key for menus
                columns={CityColumns}
                showActions={false} // Set to true if you want Edit/Delete actions
                tableTitle={"City"}
                // Pass the fields you want the search bar to filter
                filterConfigs={[
                    { field: "name", placeholder: "Search by Name" },
                    {
                        field: 'countryId',
                        type: 'select',
                        placeholder: "selectcountry",
                        showSearch: true,
                        dynamicOptions: {
                            url: "/Lookup/GetDropdownData",
                            method: "POST",
                            body: { "dropdowns": ["country"] },
                            transformData: (apiResponse: unknown) => {
                                const response = apiResponse as { country: { Name: string; Id: number }[] };
                                return response.country.map((item) => ({ label: item.Name, value: item.Id }))
                            }
                        },
                    },
                    {
                        field: "Print",
                        type: "export",
                        exportOptions: {
                            url: API_ENDPOINTS.LOOKUP.EXPORT_CITY,
                            fileName: "Cities",
                            fileType: "excel", // "csv" 
                            defaultPayload: {},
                            columns: [
                                { header: "Name", key: "name" },
                                { header: "Country", key: "country" },
                            ]
                        }
                    }

                ]}
            />
        </div>
    );
};

export default CityPage;